import { Stack, Text, ThemeIcon } from '@mantine/core';
import { IconBellOff } from '@tabler/icons-react';
import { semanticColors } from 'theme';

const EmptyState = () => (
  <Stack align="center" justify="center" gap="sm" py={48} px={16}>
    <ThemeIcon variant="light" color="gray" size={56} radius="xl">
      <IconBellOff size={28} stroke={1.5} color={semanticColors.text.muted} />
    </ThemeIcon>
    <Text fw={600} size="md">
      You&apos;re all caught up!
    </Text>
    <Text size="sm" c={semanticColors.text.secondary}>
      No new notifications
    </Text>
  </Stack>
);

export default EmptyState;
